import { Div } from "../../../base/components/native/div"
import { Scrollable } from "../../../base/utils/scrollable"

export const HomeContents = () => {
    const base = Div()

    base.cssClass({
        overflowY: 'auto',
        overflowX: 'hidden',
        marginTop: '60px',
        // paddingBottom: '50px',
        height: 'calc(100vh - 60px)',
    })
    
    return Object.assign(base, Scrollable(base))
}